// extracted by mini-css-extract-plugin
export default {"container":"delete-modal_container__clFwo","actions":"delete-modal_actions__bNpDZ","exclude":"delete-modal_exclude__2rdbe","cancel":"delete-modal_cancel__aOtGd"};